/**
 * @typedef RichmenuListResponseData
 * @property {Array<RichMenuData>} richmenus
 */
